import getters from './sales_ai.getters'
import mutations from './sales_ai.mutations'
import actions from './sales_ai.actions'

import { getField, updateField } from 'vuex-map-fields'

const initialState = () => ({
  selectedInstitution: {},
  company: '',
  domain: '',
  productUrls: '',
  productKeywords: '',
  specialInstructions: '',
  rerunReport: false,
  saveAsDefaultForUser: true,
  saveAsDefaultForGroup: false
})
export default {
  namespaced: true,
  state: initialState(),
  actions,
  getters: {
    ...getters,
    getField
  },
  mutations: {
    ...mutations,
    resetDigitalChannelsState(state) {
      let baseState = initialState()

      Object.keys(baseState).forEach(key => {
        state[key] = baseState[key]
      })
    },
    updateField
  }
}
